import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { AgGridReact } from 'ag-grid-react';
import { PageHeader, Tag } from 'antd';

import { pageSectionTitle } from '../util/Style';

const height = window.innerHeight * .80;

const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    flex: 1,
};

const columnDefs = [
    { headerName: 'Bucket', field: 'Bucket', filter: 'agNumberColumnFilter', width: 125, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Date', field: 'CreatedOn', width: 75 },
    { headerName: 'SidCode', field: 'SidCode', width: 100 },
    { headerName: 'Patient Name', field: 'CustomerName', filter: 'agTextColumnFilter', width: 350 },
    { headerName: 'Bill', field: 'Total', type: 'numericColumn', filter: 'agNumberColumnFilter', width: 125, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'IC', field: 'IC', type: 'numericColumn', filter: 'agNumberColumnFilter', width: 125, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
]

class TransactionList extends Component {

    gridRef = React.createRef();

    constructor(props) {
        super(props);
        this.store = props.store;
    }

    refreshGrid = () => {
        this.gridRef.current.api.redrawRows();
    }

    render() {

        const transactions = this.store.selectedRefTransactions;
        const referrerName = this.store.selectedReferrer;

        return (
            <PageHeader style={{ paddingTop: 0 }} title={pageSectionTitle(referrerName)} onBack={() => this.store.clearShowTransactions()}>
                <div className="ag-theme-alpine" style={{ height: height, width: '100%' }}>
                    <AgGridReact
                        rowHeight={30}
                        ref={this.gridRef}
                        defaultColDef={defaultColDef}
                        rowData={transactions}
                        rowSelection={'single'}
                        onGridReady={this.store.fetchTransactions}
                        columnDefs={columnDefs}
                        >
                    </AgGridReact>
                </div>
            </PageHeader>
        )
    }
}

export default observer(TransactionList)
